"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurrencyTaxConfiguration = void 0;
const typeorm_1 = require("typeorm/browser");
const opportunity_option_1 = require("./opportunity-option");
const currency_tax_configuration_base_1 = require("./currency-tax-configuration-base");
const data_ui_1 = require("../data-ui");
const layouts_1 = require("../data-ui/layouts");
const contact_profile_enum_1 = require("./contact-profile-enum");
let CurrencyTaxConfiguration = class CurrencyTaxConfiguration extends currency_tax_configuration_base_1.CurrencyTaxConfigurationBase {
};
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_TABLE, layouts_1.HIDE_IN_FORM),
    (0, typeorm_1.OneToMany)(() => opportunity_option_1.OpportunityOption, (opportunity) => opportunity.currencyTaxConfig),
    __metadata("design:type", Array)
], CurrencyTaxConfiguration.prototype, "opportunities", void 0);
CurrencyTaxConfiguration = __decorate([
    data_ui_1.DataUi.Permissions({
        read: [
            contact_profile_enum_1.ContactProfileEnum.FINANCE,
            contact_profile_enum_1.ContactProfileEnum.FINANCE_POWER_USER,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT_POWER_USER,
        ],
        write: [
            contact_profile_enum_1.ContactProfileEnum.FINANCE,
            contact_profile_enum_1.ContactProfileEnum.FINANCE_POWER_USER,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT_POWER_USER,
        ],
    }),
    data_ui_1.DataUi.Name({
        name: 'CurrencyTaxConfiguration',
        nameProperties: ['id'],
    }),
    (0, typeorm_1.Entity)('currency_tax_configuration', { schema: 'public' })
], CurrencyTaxConfiguration);
exports.CurrencyTaxConfiguration = CurrencyTaxConfiguration;
//# sourceMappingURL=currency-tax-configuration.js.map